import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./assets/styles/global.css";
import "./assets/styles/leaflet-customization.css";
import { initGA } from "./lib/analytics";

import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

Sentry.init({
  dsn: "https://a6b23b793e5fbf28cbc637c0913cf421@o4506950333431808.ingest.us.sentry.io/4509287920697344",
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: import.meta.env.PROD ? 1.0 : 0.1,
  // Capturar erros não tratados
  attachStacktrace: true,
  // Especialmente útil para o seu caso - captura stacktraces mais profundos
  normalizeDepth: 10,
  environment: import.meta.env.PROD ? "production" : "development",

  beforeSend(event) {
    // Adicionar mais contexto para erros de DOM
    if (
      event.exception &&
      event.exception.values &&
      event.exception.values[0].value &&
      event.exception.values[0].value.includes("removeChild")
    ) {
      // Tenta capturar mais informações sobre o DOM no momento do erro
      try {
        event.tags = event.tags || {};
        event.tags.domSnapshot = true;

        // Adicionar informações sobre o estado do DOM
        const domInfo = {
          bodyChildCount: document.body.childNodes.length,
          rootNodeId: document.getElementById("root")?.childNodes.length,
          // Outras informações relevantes sobre o DOM
        };

        event.extra = event.extra || {};
        event.extra.domState = domInfo;
      } catch (e) {
        console.error("Erro ao coletar informações do DOM:", e);
      }
    }
    return event;
  },
});

// Auto-reload quando chunks ficam obsoletos após deploy
// Pode ser removido apos remover todos React.lazy
window.addEventListener("vite:preloadError", () => {
  const hasReloaded = sessionStorage.getItem("vite:preloadError");
  if (!hasReloaded) {
    sessionStorage.setItem("vite:preloadError", "1");
    window.location.reload();
    return;
  }
  sessionStorage.removeItem("vite:preloadError");
});

// Inicializa o Google Analytics
const GA_MEASUREMENT_ID = "G-359D3H4KB2";
initGA(GA_MEASUREMENT_ID);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
